// We must define our logger options before anyone imports it!
import './utilities/logHandler';

import Vue from 'vue';
import App from './App/index';
import createRouter from './router'; // Routing manager
import { apolloProvider } from './graphql/vueApollo'; // GraphQL connection setup
import AuthMixin from './auth/mixin'; // Vue mixin for easy access to our auth API
import { store } from './store/plugin'; // Vue mixin for easy access to our application store/state
import './vueFilters'; // Register our template filters (which can also be used as in-JS utilities)
import './vueMixinUtils'; // Register all of our miscellaneous Vue mixins
import VueAnalytics from 'vue-analytics';

// Install mixins
Vue.use(AuthMixin);

Vue.config.productionTip = false;

// Install Google Analytics plugin
Vue.use(VueAnalytics, {
	id: 'UA-139478511-2',
	//These options enable Enhanced Ecommerce in Google Analytics
	ecommerce: {
		enabled: true,
		enhanced: true
	}
});

new Vue({
	router: createRouter({}), // No extra options for the router currently
	apolloProvider,
	store,
	render: h => h(App)
}).$mount('#app');
